(function () {
  'use strict';

  if (window.__sizeGuideDialogInit) return;
  window.__sizeGuideDialogInit = true;

  var dialogEl = null;
  var contentEl = null;
  var cache = null;

  function buildDialog() {
    if (dialogEl) return dialogEl;

    dialogEl = document.createElement('dialog');
    dialogEl.id = 'size-guide-dialog';
    dialogEl.className = 'size-guide-dialog';
    dialogEl.innerHTML =
      '<div class="size-guide-dialog__header">' +
        '<button type="button" class="size-guide-dialog__close-text">Cerrar</button>' +
      '</div>' +
      '<div class="size-guide-dialog__content" data-size-guide-content>' +
        '<div class="size-guide-dialog__loading">Cargando…</div>' +
      '</div>';

    document.body.appendChild(dialogEl);
    contentEl = dialogEl.querySelector('[data-size-guide-content]');

    dialogEl.querySelector('.size-guide-dialog__close-text').addEventListener('click', function () {
      dialogEl.close();
    });

    dialogEl.addEventListener('click', function (event) {
      if (event.target === dialogEl) dialogEl.close();
    });

    return dialogEl;
  }

  function loadContent(url) {
    if (cache) {
      contentEl.innerHTML = cache;
      return;
    }

    contentEl.innerHTML = '<div class="size-guide-dialog__loading">Cargando…</div>';

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var blocks = parsed.querySelectorAll('.size-guide-block');

        if (!blocks.length) {
          contentEl.innerHTML = '<p class="size-guide-dialog__error">No se ha podido cargar la guía de tallas.</p>';
          return;
        }

        var wrapper = document.createElement('div');
        blocks.forEach(function (block) {
          wrapper.appendChild(block.cloneNode(true));
        });

        cache = wrapper.innerHTML;
        contentEl.innerHTML = cache;
      })
      .catch(function () {
        contentEl.innerHTML = '<p class="size-guide-dialog__error">No se ha podido cargar la guía de tallas.</p>';
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-size-guide-trigger]');
    if (!trigger) return;

    event.preventDefault();

    var url = trigger.getAttribute('href');
    if (!url) return;

    var dialog = buildDialog();
    loadContent(url);
    dialog.showModal();
  });
})();